import { SupportedLocale } from "@/i18n";
import * as AF from "../form-items/AbstractForm";
import { useTranslation } from "react-i18next";

export const NewsPageForm = ({ lang }: { lang: SupportedLocale }) => {
  const { t } = useTranslation();
  return (
    <AF.Col>
      <AF.Text
        name={`${lang}.pageName`}
        label={t("cms.newsPage.form.pageName")}
      />
      <AF.RichText
        name={`${lang}.content`}
        label={t("cms.newsPage.form.content")}
      />
    </AF.Col>
  );
};
